import { paths } from '@/routes/paths'
import { Role } from '@/types/user.type'
import { useState, useEffect } from 'react'
import { useRouter } from '@/routes/hooks/use-router'
import { Card, CardContent } from '@/components/ui/card'

import { useAuthContext } from '../auth-provider'

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode
  allowedRoles: Role[]
  fallbackPath?: string
}

export function RoleGuard({
  children,
  allowedRoles,
  fallbackPath = paths.dashboard,
}: Props) {
  const router = useRouter()
  const { user, authenticated, loading } = useAuthContext()
  const [isChecking, setIsChecking] = useState<boolean>(true)

  const checkPermissions = async (): Promise<void> => {
    if (loading) {
      return
    }

    if (!authenticated || !user) {
      router.replace(paths.login)
      return
    }

    // ตรวจสอบ role permissions
    if (!allowedRoles.includes(user.role)) {
      router.replace(fallbackPath)
      return
    }

    setIsChecking(false)
  }

  useEffect(() => {
    checkPermissions()
  }, [authenticated, loading, user])

  if (isChecking) {
    return null
  }

  // แสดงข้อความเมื่อไม่มีสิทธิ์เข้าถึง
  if (!user || !allowedRoles.includes(user.role)) {
    return (
      <div className="flex flex-col gap-6 p-6">
        <Card className="border rounded-lg">
          <CardContent className="p-6 text-center">
            <h2 className="text-lg font-semibold text-black mb-2">
              ไม่มีสิทธิ์เข้าถึงหน้านี้
            </h2>
            <p className="text-base text-mute">
              คุณไม่มีสิทธิ์ในการเข้าถึงฟีเจอร์นี้
            </p>
          </CardContent>
        </Card>
      </div>
    )
  }

  return <>{children}</>
}
